import React from 'react';
import PropTypes from 'prop-types';
import signUpIcon from '../../../../assets/images/sign-up.svg';
import './FeaturedProfileBanner.scss';

function FeaturedProfileBanner({ consultantName }) {
  return (
    <div className="banner-container g-row">
      <img src={signUpIcon} className="banner-icon" alt="feature_profile_icon" />
      <div className="g-column">
        <h2>
          {consultantName
            ? `You're so close to connect consultants like ${consultantName}!`
            : 'Review and submit your project post'}
        </h2>
        <div>
          {consultantName
            ? (
              <div>
                Tell us about your needs so that we can help you find the best match.
              </div>
            )
            : (
              <div>
                Next: Clora will contact you and help finalize your post.
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

FeaturedProfileBanner.propTypes = {
  consultantName: PropTypes.string.isRequired,
};

export default FeaturedProfileBanner;
